import { render, staticRenderFns } from "./JGantt.vue?vue&type=template&id=3ed1e5fb&scoped=true&"
import script from "./JGantt.vue?vue&type=script&lang=ts&"
export * from "./JGantt.vue?vue&type=script&lang=ts&"
import style0 from "./JGantt.vue?vue&type=style&index=0&id=3ed1e5fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1e5fb",
  null
  
)

export default component.exports